import { useCountryName } from "./countryNames";

export const CountryName = ({ country }: { country: { alpha3Code?: string | null; name: string } }) => {
  const nameOf = useCountryName();
  return <>{nameOf(country)}</>;
};
